import { createReducer, on } from '@ngrx/store';
import { ClientProfileState } from './diet.models';
import * as ClientActions from './diet.actions';

export const initialState: ClientProfileState = {
  clients: [],
  selectedClient: null,
  loading: false,
  loaded: false,
  error: null,
};

export const clientReducer = createReducer(
  initialState,
  on(ClientActions.loadClientProfiles, (state) => ({
    ...state,
    loading: !state.loaded,
  })),
  on(ClientActions.loadClientProfilesSuccess, (state, { clients }) => ({
    ...state,
    clients,
    loaded: true,
    loading: false,
  })),
  on(ClientActions.loadClientProfilesFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: false,
    loading: false,
  })),
  on(ClientActions.selectClientProfile, (state, { id }) => ({
    ...state,
    selectedPlan: state.clients.find((client) => client.userUID === id) || null,
  }))
);
